import { BaseCard } from '@nebula/cards';
import {
  BodyLarge400,
  BodyMedium400,
  TitleLarge500,
  TitleMedium500,
  TitleSmall500,
  TitleXSmall500,
} from '@nebula/global-styles';
import styled from 'styled-components';

export const OneTimePaymentCard = styled(BaseCard)`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  padding: 16px;
  > ${TitleLarge500} {
    margin-top: 0;
    margin-bottom: 0;
  }
  > ${TitleMedium500} {
    margin-top: 0;
    margin-bottom: 0;
  }
  > ${TitleSmall500} {
    margin-top: 0;
    margin-bottom: 0;
  }
  > ${TitleXSmall500} {
    margin-top: 0;
    margin-bottom: 0;
  }
  > ${BodyLarge400} {
    margin-block-start: 8px;
    margin-block-end: 0;
  }
  > ${BodyMedium400} {
    margin-block-start: 8px;
    margin-block-end: 0;
  }

  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    padding: 24px;
  }
`;

export const AmountDueSection = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  border-bottom: ${props => `1px solid ${props.theme.color.decorative.sapphire[20]}`};
  > ${TitleSmall500} {
    margin: 16px 0px;
  }
  > ${TitleXSmall500} {
    margin: 16px 0px;
  }
`;

export const PayWithSection = styled.div`
  > ${BodyLarge400} {
    margin-block-start: 16px;
    margin-block-end: 4px;
  }
  > ${BodyMedium400} {
    margin-block-start: 16px;
    margin-block-end: 4px;
  }
`;

export const PaymentSourceSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  > ${TitleSmall500} {
    margin: 12px 0px;
  }
`;

export const PaymentIconContainer = styled.div.attrs({
  'aria-hidden': 'true',
})`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PaymentIcon = styled.img`
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
`;

export const PaymentSummarySection = styled.div`
  border-top: ${props => `1px solid ${props.theme.color.decorative.sapphire[20]}`};
  margin-top: 12px;
  padding-top: 24px;
`;

export const Form = styled.form`
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    max-width: 19.4375rem;
  }
`;

export const Label = styled(TitleXSmall500).attrs({
  as: 'label',
})`
  margin: 0.25rem 0 0.5rem;
`;
